import React from "react";
import classes from "./DashboardStatsCardStyles.module.scss";
import { uniqueId } from "lodash";

export type DashbordStatsCardHeader = {
  title: string;
  tooltip?: JSX.Element;
  ammount: string;
};

export type DashbordStatsCardStats = {
  title: string;
  content: string | JSX.Element;
};

type Props = {
  headerItems: DashbordStatsCardHeader[];
  statsItems: DashbordStatsCardStats[];
};

export const DashboardStatsCard = ({ headerItems, statsItems }: Props) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.headerWrapper}>
        {headerItems.map((headerItem) => (
          <div key={uniqueId(headerItem.title)} className={classes.headerItemWrapper}>
            <span className={classes.headerItemTitle}>
              {headerItem.title} {headerItem.tooltip ? headerItem.tooltip : ""}{" "}
            </span>
            <span className={classes.headerItemContent}>{headerItem.ammount}</span>
          </div>
        ))}
      </div>
      <div className={classes.statsWrapper}>
        {statsItems.map((statsItem) => (
          <div key={uniqueId(statsItem.title)} className={classes.statsItemWrapper}>
            <span className={classes.statsItemTitle}>{statsItem.title}</span>
            <span className={classes.statsItemContent}>{statsItem.content}</span>
          </div>
        ))}
      </div>
    </div>
  );
};


